module.exports = __webpack_public_path__ + "static/home-4e0a2d8e00b4d7753c197ebd8560369a.png";